/* Enhances only Tat-Targa campaign forms. Native POST remains the no-JS fallback. */
(() => {
  if (window.ttStorefrontReady) return;
  window.ttStorefrontReady = true;
  // Copy the current selection before Minion builds the sticky form's FormData.
  document.addEventListener('submit', (event) => {
    const stickyForm = event.target;
    if (!(stickyForm instanceof HTMLFormElement)) return;
    const stickyId = stickyForm.getAttribute('id') || '';
    if (!stickyId.startsWith('tt-sticky-form-')) return;
    const sectionId = stickyId.slice('tt-sticky-form-'.length);
    const mainForm = document.getElementById('product-form-' + sectionId);
    if (!mainForm) return;
    const mainVariant = mainForm.querySelector('[name="id"]');
    const mainQuantity = mainForm.querySelector('[name="quantity"]');
    if (mainVariant) stickyForm.querySelector('[name="id"]').value = mainVariant.value;
    if (mainQuantity) stickyForm.querySelector('[name="quantity"]').value = mainQuantity.value;
  }, true);
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-tt-add]');
    if (!form || !window.fetch || !window.FormData) return;
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cart || typeof cart.getSectionsToRender !== 'function' || typeof cart.renderContents !== 'function') return;
    event.preventDefault();
    if (form.dataset.busy === 'true') return;
    const button = form.querySelector('button[type="submit"]');
    const label = button.querySelector('span');
    const originalLabel = label.textContent;
    const message = form.querySelector('.tt-form-message');
    form.dataset.busy = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding…';
    message.hidden = true;
    let added = false;
    try {
      const body = new FormData(form);
      body.append('sections', cart.getSectionsToRender().map((section) => section.id).join(','));
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
      const response = await fetch(form.action.replace(/\.js$/, '') + '.js', {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'This item could not be added. Please try again.');
      added = true;
      try {
        cart.renderContents(result);
        cart.classList.remove('is-empty');
      } catch (_) {
        window.location.assign((window.routes && window.routes.cart_url) || '/cart');
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tt-offers', productVariantId: body.get('id') });
      }
      message.textContent = 'Added to your basket.';
    } catch (error) {
      message.textContent = added ? 'Added to your basket. Open your basket to continue.' : (error.message || 'Please check your connection and try again.');
    } finally {
      message.hidden = false;
      form.dataset.busy = 'false';
      button.disabled = false;
      button.removeAttribute('aria-busy');
      label.textContent = originalLabel;
    }
  });
})();
